import { MegaraxUri, PriceListTab } from "../uri";
import { crmVisitRedirects } from "./crmVisitRedirects";
import { LegacyRedirect, redirect, uuidParam } from "./redirect";

const priceListTab = (tab: string): PriceListTab =>
  tab === "proposals" || tab === "propozycje" ? "proposals" : "current";

const priceListRedirects: LegacyRedirect[] = [
  redirect("/crm/pos/cenniki/nowy", () => MegaraxUri("megarax://crm/price-lists/new")),
  redirect("/crm/pos/price-lists/new", () => MegaraxUri("megarax://crm/price-lists/new")),
  redirect("/crm/pos/cenniki/:uuid/:tab/*", ({ uuid, tab }) =>
    MegaraxUri("megarax://crm/price-list-tabs/id/{id}/{tab}", { id: uuid, tab: priceListTab(tab) }),
  ),
  redirect("/crm/pos/price-lists/:uuid/:tab/*", ({ uuid, tab }) =>
    MegaraxUri("megarax://crm/price-list-tabs/id/{id}/{tab}", { id: uuid, tab: priceListTab(tab) }),
  ),
  redirect("/crm/pos/cenniki/:uuid", ({ uuid }) => MegaraxUri("megarax://crm/price-lists/id/{id}", { id: uuid })),
  redirect("/crm/pos/price-lists/:uuid", ({ uuid }) => MegaraxUri("megarax://crm/price-lists/id/{id}", { id: uuid })),
  redirect("/crm/pos/cenniki", () => MegaraxUri("megarax://crm/price-lists")),
  redirect("/crm/pos/price-lists", () => MegaraxUri("megarax://crm/price-lists")),
];

const customerRedirects: LegacyRedirect[] = [
  redirect("/crm/customer-list-view", () => MegaraxUri("megarax://crm/customers/new-list")),
  redirect("/crm/customer-map-view", () => MegaraxUri("megarax://crm/customers/new-map")),
  redirect("/crm/customer-analytics-view", () => MegaraxUri("megarax://crm/customers/new-customer-analytics")),
  redirect("/crm/customers/views/list", () => MegaraxUri("megarax://crm/customers/new-list")),
  redirect("/crm/customers/views/map", () => MegaraxUri("megarax://crm/customers/new-map")),
  redirect("/crm/customers/views/analytics", () => MegaraxUri("megarax://crm/customers/new-customer-analytics")),
  redirect("/crm/customers/views/id/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/customer-lists/id/{id}", { id }) : undefined;
  }),
  redirect("/crm/customers/:uuid/*", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/customer-lists/id/{id}", { id }) : undefined;
  }),
];

export const crmRedirects: LegacyRedirect[] = [
  redirect("/crm/user-home", () => MegaraxUri("megarax://crm/home")),
  redirect("/crm/pos", () => MegaraxUri("megarax://crm/my-feed")),
  redirect("/crm/training/*", () => MegaraxUri("megarax://crm/training-calendar")),

  ...customerRedirects,

  redirect("/crm/orders/:number", ({ number }) => MegaraxUri("megarax://crm/orders/number/{number}", { number })),
  redirect("/crm/order-drafts/:uuid/*", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/order-drafts/id/{id}", { id }) : undefined;
  }),
  redirect("/crm/my-affiliate-codes/:id/*", ({ id }) =>
    id === "id" ? undefined : MegaraxUri("megarax://crm/my-affiliate-codes/id/{id}", { id }),
  ),

  redirect("/crm/region-profit-metrics/:region", ({ region }) =>
    MegaraxUri("megarax://crm/regions/id/{id}", { id: region }),
  ),
  redirect("/crm/region-profit-metrics", () => MegaraxUri("megarax://crm/regions")),
  redirect("/crm/regions/region/:region/*", ({ region }) =>
    MegaraxUri("megarax://crm/regions/id/{id}", { id: region }),
  ),
  redirect("/crm/regions/:region", ({ region }) =>
    region === "id" ? undefined : MegaraxUri("megarax://crm/regions/id/{id}", { id: region }),
  ),

  ...priceListRedirects,

  redirect("/crm/pos/moje_ankiety_cenowe", () => MegaraxUri("megarax://crm/price-reports")),
  redirect("/crm/pos/my-price-reports", () => MegaraxUri("megarax://crm/price-reports")),
  redirect("/crm/pos/ankiety_cenowe/produkty", () => MegaraxUri("megarax://crm/price-report-products")),
  redirect("/crm/pos/price-reports/products", () => MegaraxUri("megarax://crm/price-report-products")),
  redirect("/crm/pos/ankiety_cenowe", () => MegaraxUri("megarax://crm/price-report-products")),
  redirect("/crm/pos/price-reports", () => MegaraxUri("megarax://crm/price-report-products")),

  ...crmVisitRedirects,

  redirect("/crm/pos/trasy/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/trade-routes/id/{id}", { id }) : undefined;
  }),
  redirect("/crm/pos/trade-routes/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/trade-routes/id/{id}", { id }) : undefined;
  }),
  redirect("/crm/pos/trasy", () => MegaraxUri("megarax://crm/trade-routes")),
  redirect("/crm/pos/trade-routes", () => MegaraxUri("megarax://crm/trade-routes")),
];
